module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-133.dc6b9325.svg";